import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Cards } from '@sorare/core/src/atoms/icons/Cards';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { ANY_SPORT_PLAYERS_SLUG_CARDS } from '@sorare/core/src/constants/__generated__/routes';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';
import { desktopAndAbove } from '@sorare/core/src/style/mediaQuery';
import { regularMaterial } from '@sorare/core/src/style/utils';

const Footer = styled(Horizontal)`
  padding: var(--double-unit);
  position: sticky;
  bottom: 0;
  z-index: 1;
  ${regularMaterial}
  @media ${desktopAndAbove} {
    backdrop-filter: none;
    background-color: var(--c-black);
  }
  border-left: 1px solid var(--c-nd-150);
  border-top: 1px solid var(--c-nd-150);
`;

type Props = {
  playerSlug: string;
  sport: Sport;
};

export const PlayerMarketDrawerFooter = ({ playerSlug, sport }: Props) => {
  const { up: isDesktopOrAbove } = useScreenSize('desktop');
  return (
    <Footer>
      <Button
        to={generateSportPath(ANY_SPORT_PLAYERS_SLUG_CARDS, {
          sport,
          params: { slug: playerSlug },
        })}
        startIcon={<Cards />}
        size={isDesktopOrAbove ? 'large' : 'medium'}
        color={isDesktopOrAbove ? 'tertiary' : 'quaternary'}
        fullWidth
      >
        <FormattedMessage
          id="PlayerMarketDrawer.content.cardSupply"
          defaultMessage="Card Supply"
        />
      </Button>
    </Footer>
  );
};
